"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUseNative = exports.isVersionCompatible = void 0;
var event_tracking_core_1 = require("@al/event-tracking-core");
var APP_MIN_VERSION = {
    akulaku: {
        android: "5.1.10",
        ios: "5.1.10",
    },
    silvrrplus: {
        android: "1.0.0",
        ios: "1.0.0",
    },
};
function deepMerge(target, source) {
    if (target === void 0) { target = {}; }
    if (source === void 0) { source = {}; }
    for (var _i = 0, _a = Object.keys(source); _i < _a.length; _i++) {
        var key = _a[_i];
        var currenttarget = target[key];
        var currentsource = source[key];
        if (currenttarget) {
            var objectsource = typeof currentsource === "object";
            var objecttarget = typeof currenttarget === "object";
            if (objectsource && objecttarget) {
                Array.isArray(currenttarget) && Array.isArray(currentsource)
                    ? (target[key] = currenttarget.concat(currentsource))
                    : deepMerge(currenttarget, currentsource);
                continue;
            }
        }
        target[key] = currentsource;
    }
    return target;
}
function isVersionCompatible(appVersionInfo) {
    var appInfo = (0, event_tracking_core_1.getAppInfo)();
    if (appInfo.appName && appInfo.version) {
        var _a = appVersionInfo !== null && appVersionInfo !== void 0 ? appVersionInfo : {}, operator = _a.operator, versions = _a.versions;
        var versionInfo = deepMerge(APP_MIN_VERSION, versions);
        var minVersions = versionInfo[appInfo.appName] || {};
        var ios = minVersions.ios;
        var android = minVersions.android;
        var compareVersion = (0, event_tracking_core_1.isAndroid)() ? android : ios;
        if (operator === "eq") {
            // eslint-disable-next-line eqeqeq
            return appInfo.version == compareVersion;
        }
        return appInfo.version >= compareVersion;
    }
    return false;
}
exports.isVersionCompatible = isVersionCompatible;
function isUseNative(isNative, appVersionInfo) {
    // akulaku 或 silvrrplus app 内判断版本号，其他情况下不处理版本号，由业务自行决定 is_native 即可
    return ((0, event_tracking_core_1.isApp)() && isNative && isVersionCompatible(appVersionInfo)) || (isNative && !(0, event_tracking_core_1.isApp)());
}
exports.isUseNative = isUseNative;
